import { createPortal } from 'react-dom';
import './Tooltip.scss';

/**
 * Shared tooltip component for displaying title and optional description.
 * Renders via portal to escape CSS transform scaling and positioning contexts.
 * 
 * @param {Object} props
 * @param {boolean} props.visible - Whether to show the tooltip
 * @param {number} props.x - X position (centered on this point)
 * @param {number} props.y - Y position (tooltip appears relative to this point)
 * @param {string} props.title - Tooltip title text
 * @param {string} [props.description] - Optional description text
 * @param {string} [props.placement='top'] - Placement: 'top' or 'bottom'
 */
function Tooltip({ visible, x, y, title, description, placement = 'top' }) {
  if (!visible) return null;

  const className = placement === 'bottom' 
    ? 'tooltip tooltip--bottom'
    : 'tooltip';

  return createPortal(
    <div 
      className={className}
      style={{ left: x, top: y }}
    >
      <div className="tooltip__title">{title}</div>
      {description && (
        <div className="tooltip__description">{description}</div>
      )}
    </div>,
    document.body
  );
}

export default Tooltip;
